/**
 * @generated SignedSource<<b8934286ba06157b289ed3a044440f30>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type carouselArticleSeriesCarouselArticle$data = {
  readonly entityId: string;
  readonly seriesContainer: {
    readonly entityId: string;
    readonly headline: string | null | undefined;
    readonly series: ReadonlyArray<{
      readonly entityId?: string;
      readonly urlAlias?: string;
      readonly " $fragmentSpreads": FragmentRefs<"articleSeriesCarouselContent">;
    } | null | undefined> | null | undefined;
    readonly socialHeadline: string | null | undefined;
    readonly urlAlias: string;
    readonly " $fragmentSpreads": FragmentRefs<"entityLink">;
  } | null | undefined;
  readonly " $fragmentType": "carouselArticleSeriesCarouselArticle";
};
export type carouselArticleSeriesCarouselArticle$key = {
  readonly " $data"?: carouselArticleSeriesCarouselArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"carouselArticleSeriesCarouselArticle">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urlAlias",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "carouselArticleSeriesCarouselArticle",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Article",
      "kind": "LinkedField",
      "name": "seriesContainer",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "headline",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "socialHeadline",
          "storageKey": null
        },
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "series",
          "plural": true,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/),
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "articleSeriesCarouselContent"
                }
              ],
              "type": "Content",
              "abstractKey": "__isContent"
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "entityLink"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Article",
  "abstractKey": null
};
})();

(node as any).hash = "815e99eb4fd869141a56bf23babf13cf";

export default node;
